import React from 'react';
import styled from 'styled-components';


const TextAreaBlock = styled.textarea`
    height: ${props => props.height || '160px'};
    display: ${props => props.visible ? 'block' : 'none'};
    width: 100%;
    padding: 10px 15px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    resize: none;

    :focus {
        border: 1px solid #ffc742;
        outline: 0;
    }

    ::-webkit-input-placeholder {
        color: #ccc;
    }

    ::-moz-placeholder {
        color: #ccc;
    }

    ::-ms-input-placeholder {
        color: #ccc;
    }

    ::placeholder {
        color: #ccc;
    }
`;

const TextArea = ({ height, onChange, placeholder, visible = true, value = null, handleFocus ,handleBlur }) => {

    const onFocus = () => {
        if(handleFocus&&handleFocus!==undefined) {
            handleFocus();
        }
    }
    const onBlur = () => {
        if(handleBlur&&handleBlur!==undefined) {
            handleBlur();
        }
    }

    if (value !== null) {
        return (<TextAreaBlock onChange={onChange}
            placeholder={placeholder} visible={visible} value={value} height={height} onFocus={onFocus} onBlur={onBlur}/>);
    } else {
        return (<TextAreaBlock onChange={onChange}
            placeholder={placeholder} visible={visible} height={height} onFocus={onFocus} onBlur={onBlur}/>);
    }
};

export default TextArea;